import { ACTION } from '../constants';
import request from '../utils/request';
import { requestConfig } from '../config/apiResource';


export const selectedLang = data => ({type:ACTION.GET_LANG_SUCCESS,data});

export function showMainLoader() {
    return {type:ACTION.SHOW_MAIN_LOADER}
}


export function hideMainLoader() {
    return {type:ACTION.HIDE_MAIN_LOADER}
}

export function getMenu() {
    return dispatch => {
        // dispatch(showMainLoader());
        return request(requestConfig.getMenu())
            .then((json) => {
                // dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_MENU_SUCCESS, data: json.data });
                return json;
            }).catch((error) => {
                // dispatch(hideMainLoader());
                console.log("Got Error with Menu data: " + error)
            });
    }
}

export function saveBreadcrumb(data) {
    return {
        type: "SAVE_BREADCRUMB",
        data: data,
    }
}
export function updateEcartDetails(params){
    return dispatch => {
        dispatch({ type: ACTION.SAVE_CART_DETAILS, data: params});
    }
}
export function promotionalHeader() {
    return dispatch => {
        // dispatch(showMainLoader());
        return request(requestConfig.promotionalHeader())
            .then((json) => {
                // dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_PROMOTIONAL_HEADER, data: json });
                return json;
            }).catch((error) => {
                // dispatch(hideMainLoader());
                console.log("Got Error with Promotional Header data: " + error)
            });
    }
}